import { render, staticRenderFns } from "./editDraw.vue?vue&type=template&id=c1c8dbae&scoped=true&"
import script from "./editDraw.vue?vue&type=script&lang=js&"
export * from "./editDraw.vue?vue&type=script&lang=js&"
import style0 from "./editDraw.vue?vue&type=style&index=0&id=c1c8dbae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c8dbae",
  null
  
)

export default component.exports